import api from "./api";

const state = {
  step: 1,
  one: {
    nameFirst: "",
    nameMiddle: "",
    nameLast: "",
    address: {
      street: "",
      city: "",
      state: "",
      zip: "",
    },
    phone: "",
    email: "",
  },
  two: {
    propertyAddress: {
      street: "",
      city: "",
      state: "",
      zip: "",
    },
    mexicanPhone: "",
    mexicanMunicipality: "",
  },
  three: {
    applicant_type: "",
    property_use: "",
    property_type: "",
    roof_type: "",
    wall_type: "",
    underground_floors: "",
    storm_shutters: "",
    storm_shutters_hurricane: false,
    adjacent_structures: "",
    number_of_stories: "",
    distance_from_coastline: "",
    distance_above_sea: "",
  },
  four: {
    securities: [],
  },
  five: {
    dwelling_amount: "",
    contents: "",
    burglary: "",
    loss_of_rents: false,
    liability: "",
    valuable_items: "",
    money_securties: "",
    glass_breakage: "",
    electronics: "",
  },
  loss_history: [],
  other_structures: [],
  outdoor_property: [],
  uploadedFile: {
    localName: "",
    serverName: "",
  },
  submitting: false,
};

export default {
  state: { ...state },
  mutations: {
    ADD_STRUCTURE(state) {
      const newStructure = { name: "", amount: "" };
      state.other_structures = [...state.other_structures, newStructure];
    },
    REMOVE_STRUCTURE(state, index) {
      const { other_structures } = state;
      state.other_structures = [
        ...other_structures.slice(0, index),
        ...other_structures.slice(index + 1),
      ];
    },
    UPDATE_STRUCTURE(state, payload) {
      const { index, structure } = payload;
      const { other_structures } = state;
      state.other_structures = [
        ...other_structures.slice(0, index),
        structure,
        ...other_structures.slice(index + 1),
      ];
    },
    ADD_PROPERTY(state) {
      const newItem = { name: "", amount: "" };
      state.outdoor_property = [...state.outdoor_property, newItem];
    },
    REMOVE_PROPERTY(state, index) {
      const { outdoor_property } = state;
      state.outdoor_property = [
        ...outdoor_property.slice(0, index),
        ...outdoor_property.slice(index + 1),
      ];
    },
    UPDATE_PROPERTY(state, payload) {
      const { index, property } = payload;
      const { outdoor_property } = state;
      state.outdoor_property = [
        ...outdoor_property.slice(0, index),
        property,
        ...outdoor_property.slice(index + 1),
      ];
    },
    ADD_LOSS_HISTORY_ITEM(state) {
      const item = { type: "", amount: "", date: "" };
      state.loss_history = [...state.loss_history, item];
    },
    REMOVE_LOSS_HISTORY_ITEM(state, index) {
      const { loss_history } = state;
      state.loss_history = [
        ...loss_history.slice(0, index),
        ...loss_history.slice(index + 1),
      ];
    },
    UPDATE_LOSS_HISTORY_ITEM(state, payload) {
      const { index, item } = payload;
      const { loss_history } = state;
      state.loss_history = [
        ...loss_history.slice(0, index),
        item,
        ...loss_history.slice(index + 1),
      ];
    },
    UPDATE_FORM_ONE(state, data) {
      state.one = { ...state.one, ...data };
    },
    UPDATE_FORM_TWO(state, data) {
      state.two = { ...state.two, ...data };
    },
    UPDATE_FORM_THREE(state, data) {
      state.three = { ...state.three, ...data };
    },
    SET_SECURITIES(state, data) {
      state.four.securities = data;
    },
    UPDATE_FORM_FIVE(state, data) {
      state.five = { ...state.five, ...data };
    },
    UPDATE_UPLOADED_FILE(state, uploadedFile) {
      console.log({ uploadedFile });
      state.uploadedFile = { ...uploadedFile };
    },
    NEXT_STEP(state) {
      state.step = state.step + 1;
    },
    PREV_STEP(state) {
      state.step = state.step - 1;
    },
    SUBMIT_REQUEST(state) {
      state.submitting = true;
    },
    SUBMIT_RECEIVE_ERROR(state) {
      state.submitting = false;
    },
  },
  actions: {
    addStructure({ commit }) {
      commit("ADD_STRUCTURE");
    },
    removeStructure({ commit }, index) {
      commit("REMOVE_STRUCTURE", index);
    },
    updateStructure({ commit }, { index, structure }) {
      commit("UPDATE_STRUCTURE", { index, structure });
    },
    addProperty({ commit }) {
      commit("ADD_PROPERTY");
    },
    removeProperty({ commit }, index) {
      commit("REMOVE_PROPERTY", index);
    },
    updateProperty({ commit }, { index, property }) {
      commit("UPDATE_PROPERTY", { index, property });
    },
    addLossHistoryItem({ commit }) {
      commit("ADD_LOSS_HISTORY_ITEM");
    },
    removeLossHistoryItem({ commit }, index) {
      commit("REMOVE_LOSS_HISTORY_ITEM", index);
    },
    updateLossHistoryItem({ commit }, { index, item }) {
      commit("UPDATE_LOSS_HISTORY_ITEM", { index, item });
    },
    nextStep({ commit }) {
      commit("NEXT_STEP");
    },
    prevStep({ commit }) {
      commit("PREV_STEP");
    },
    updateFormOne({ commit }, data) {
      commit("UPDATE_FORM_ONE", data);
    },
    updateFormTwo({ commit }, data) {
      commit("UPDATE_FORM_TWO", data);
    },
    updateFormThree({ commit }, data) {
      commit("UPDATE_FORM_THREE", data);
    },
    updateFormFive({ commit }, data) {
      commit("UPDATE_FORM_FIVE", data);
    },
    updateUploadedFile({ commit }, data) {
      commit("UPDATE_UPLOADED_FILE", data);
    },
    setSecurities({ commit }, data) {
      commit("SET_SECURITIES", data);
    },
    async submitData({ commit, state }) {
      commit("SUBMIT_REQUEST");
      const homeownerData = {
        ...state.one,
        ...state.two,
        ...state.three,
        ...state.four,
        ...state.five,
        outdoor_property: state.outdoor_property,
        other_structures: state.other_structures,
        loss_history: state.loss_history,
        uploadedFile: state.uploadedFile,
      };
      let response = null;
      try {
        response = await api.postHomeownersQuoteRequest(homeownerData);
      } catch {
        console.log("failed");
        commit("SUBMIT_RECEIVE_ERROR");
        alert("Could not submit your request");
        return;
      }
      if (response.status == 201) {
        console.log({ response });
        window.location = "/homeowners-insurance/thank-you";
      } else {
        console.log("bad response");
        commit("SUBMIT_RECEIVE_ERROR");
        alert("Could not submit your request");
      }
    },
  },
};
